/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1, showEditModal = null, showDeleteModal = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento)
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    }
    // {
    //   title: "Celular",
    //   dataIndex: "celular",
    //   key: "celular",
    //   sorter: (a, b) => a.celular.localeCompare(b.celular),
    //   sortDirections: ["descend", "ascend"]
    // }
    // {
    //   title: "Acciones",
    //   key: "action",
    //   render: (record) => (
    //     <span>
    //       <Button icon={<DeleteOutlined />} onClick={() => showDeleteModal(record)} />
    //     </span>
    //   )
    // }
  ];
}
